module.exports = __webpack_public_path__ + "static/media/title.7495e4f3.png";